import { ArrowLeft, Send } from "lucide-react";
import { useEffect, useState, type FormEvent } from "react";
import { Link, useSearchParams } from "react-router-dom";
import type { ActivitySnapshot, SupportCase } from "../../shared/types";
import { Spinner } from "../components/Spinner";
import { api } from "../lib/api";

export function MissingCreditPage() {
  const [params] = useSearchParams();
  const [activity, setActivity] = useState<ActivitySnapshot>();
  const [attemptId, setAttemptId] = useState(params.get("attempt") || "");
  const [explanation, setExplanation] = useState("");
  const [reference, setReference] = useState("");
  const [created, setCreated] = useState<SupportCase>();
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { void api.activity().then(setActivity).catch((reason) => setError(String(reason))); }, []);
  const submit = async (event: FormEvent) => {
    event.preventDefault();
    setBusy(true);
    setError("");
    try {
      setCreated(await api.createMissingCredit(attemptId, explanation, reference || undefined));
    } catch (reason) {
      setError(reason instanceof Error ? reason.message : "Unable to submit your case.");
    } finally {
      setBusy(false);
    }
  };
  if (!activity && !error) return <Spinner />;
  if (created) return <div className="form-page page-width"><section className="success-panel"><span>✓</span><p className="eyebrow">CASE RECEIVED</p><h1>We'll review what happened.</h1><p>Your case reference is <strong>{created.id.split("_").pop()?.slice(0, 8) || created.id.slice(0, 8)}</strong>. A claim never creates an automatic credit; a Bucks operator will verify the activity.</p><Link className="button" to="/activity">Back to Activity</Link></section></div>;
  return (
    <div className="form-page page-width">
      <Link className="back-link" to="/activity"><ArrowLeft />Activity</Link>
      <section className="support-card">
        <p className="eyebrow">WE CAN HELP</p><h1>Missing credit?</h1><p>Choose the offer attempt. Bucks already knows your account and start time, so you only need to add what happened.</p>
        <form onSubmit={submit}>
          <label>Offer attempt<select required value={attemptId} onChange={(event) => setAttemptId(event.target.value)}><option value="">Choose an attempt</option>{activity?.attempts.map((attempt) => <option key={attempt.id} value={attempt.id}>{attempt.offerTitle} · {new Date(attempt.startedAt).toLocaleDateString()}</option>)}</select></label>
          <label>What happened?<textarea required minLength={10} rows={5} value={explanation} onChange={(event) => setExplanation(event.target.value)} placeholder="I completed the signup and received a confirmation email…" /></label>
          <label>Confirmation reference <span className="label-help">Optional</span><input value={reference} onChange={(event) => setReference(event.target.value)} placeholder="Confirmation number or email subject" /></label>
          {error && <div className="form-error" role="alert">{error}</div>}
          <button className="button" disabled={busy}>{busy ? "Submitting…" : "Submit for review"}<Send /></button>
        </form>
      </section>
    </div>
  );
}
